module.exports = __webpack_public_path__ + "static/media/streamlined-earing_720x480.42114f4b.jpg";